export const proposalRequirement = 'Before providing your service, you need to send a proposal to the startup with the terms and other details along with it.';

export default null;
